<div class="opcionesGrafica">
  <div class="acciones">
      <button mat-icon-button class="darkGreyLynx marginTop8" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button disabled  mat-menu-item>
            <mat-icon class="darkGreyLynx">get_app</mat-icon>
            <span>Descargar reporte</span>
          </button>
          <button disabled (click)="changeChartType()" mat-menu-item >
            <mat-icon class="darkGreyLynx">bar_chart</mat-icon>
            <span>Tipo de gráfica</span>
          </button>
          <button disabled mat-menu-item>
            <mat-icon class="darkGreyLynx">delete</mat-icon>
            <span>Eliminar gráfica</span>
          </button>
        </mat-menu>
   
  </div>
</div>